<template>
  <a-layout>
    <a-space>
      <vxe-input v-model="query['container.no']" placeholder="business.label.palletNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <a-button type="primary" @click="review">{{ $t('button.reviewPass') }}</a-button>
      <a-button type="primary" @click="reject">{{ $t('button.reviewReject') }}</a-button>
    </a-space>
    <shelf-task ref="shelfTask" select-type="radio" :stereoscopic="true" :scroll-y="scrollY"/>
  </a-layout>
</template>

<script>
import PageUtil from '@/components/Pagination/PageUtil.vue'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ShelfByStereoscopic',
    components: {ShelfTask, PageUtil},
    data() {
      return {
        data: [],
        query: {
          'container.no': '',
          storageRoomType: 2,
          passed: false
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77),// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    methods: {
      refresh() {
        this.$refs.shelfTask.getData(this.query)
      },
      review() {
        this.$refs.shelfTask.review()
      },
      reject() {
        this.$refs.shelfTask.reject()
      },
      reset() {
        this.query = {
          'container.no': '',
          storageRoomType: 2,
          passed: false
        }
        this.$refs.shelfTask.reset()
      }
    }
  }
</script>